<div class="p-4">
  <h5>Проверка номера посылки</h5>
  <div>
    <input pInputText placeholder="Введите трек-номер" [(ngModel)]="trackNum" autofocus (keyup)="onKeyUp($event)">
    <p-button class="pl-1" label="Проверить" (click)="checkTrack()" gtagEvent trackOn='click'
      action='check-track-by-admin' category="usage_analyse" [params]="{track_num: trackNum}"></p-button>
  </div>

  @if(trackInfo) {
  <div class="">
    <table class="infoTable p-4">
      <tr [ngClass]="{'table-danger': (trackInfo.deleted === 1)}">
        <td>Трек-номер</td>
        <td>
          {{trackInfo.tracknum}}
          <div *ngIf="trackInfo.deleted == 1">
            <p class="deleted_info">(удалено пользователем)</p>
            <div>
              <button pButton label="Восстановить" (click)="restoreTrack()"></button>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>Вес:</td>
        <td>{{trackInfo.weight}}</td>
      </tr>
      <tr>
        <td>Описание</td>
        <td>{{trackInfo.title}}</td>
      </tr>
      <tr>
        <td>Клиент</td>
        <td>
          @if(trackInfo.client_code){
          {{trackInfo.client_code}} @if(trackInfo.client_full_name) { ({{trackInfo.client_full_name}})}
          <div class="infoBtn" (click)="showClientWnd()"> i </div>
          } @else {<нет данных>}
        </td>
      </tr>
      <tr>
        <td>Статус посылки</td>
        <td>{{trackInfo.status}}</td>
      </tr>
      <tr>
        <td>Кто забрал</td>
        <td>{{trackInfo.pickedup_client_code}} {{trackInfo.pickedup_client_full_name}}</td>
      </tr>
      <tr>
        <td>Дата последнего события</td>
        <td>{{trackInfo.last_history_date | date:"dd.MM.yyyy"}}</td>
      </tr>
      <tr>
        <td>Комментарий</td>
        <td>{{trackInfo.comment}}</td>
      </tr>
      <tr>
        <td>Пользователь</td>
        <td>{{trackInfo.user}}</td>
      </tr>
    </table>

    @if(trackHistory) {
    <div class="pt-2">
      <h5>История статусов:</h5>
      <table class="infoTable p-4">
        <tr>
          <th>Дата</th>
          <th>Статус</th>
          <th>Склад</th>
          <th>Клиент</th>
          <th>Сотрудник</th>
          <th></th>
        </tr>
        @for(h of trackHistory; track h.dt) {
        <tr>
          <td>{{h.dt | date:"dd.MM.yyyy"}}</td>
          <td>{{h.status}}</td>
          <td>{{h.store}}</td>
          <td>{{h.owner_name}}</td>
          <td>{{h.user_name}}</td>
          <td>
            @if(trackInfo && authInfo?.userRole === 'admin') {
            <div class="flex justify-end flex-wrap">
              <p-button icon="pi pi-trash" severity="danger" pTooltip="Удалить статус" tooltipPosition="left" (click)="removeHistory(h.id)"></p-button>
            </div>
            }
          </td>
        </tr>
        } @empty {<div class="pt-8">НЕТ ДАННЫХ</div>}
      </table>
    </div>
    }
  </div>
  } @else if(trackInfo === null) {
  <div>
    <h3 class="pt-8">НЕТ ДАННЫХ</h3>
  </div>
  }

  <p-dialog header="Информация о клиенте" [(visible)]="showClientDialog" [modal]="true">
    <div>
      <table class="infoTable">
        <tr>
          <td class="alignRight">Имя:</td>
          <td>{{currentClientToView?.first_name}}</td>
        </tr>
        <tr>
          <td class="alignRight">Фамилия:</td>
          <td>{{currentClientToView?.last_name}}</td>
        </tr>
        <tr>
          <td class="alignRight">Клиент:</td>
          <td>{{currentClientToView?.client_code}}</td>
        </tr>
        <tr>
          <td class="alignRight">Город:</td>
          <td>{{currentClientToView?.client_city}}</td>
        </tr>
        <tr>
          <td class="alignRight">Email:</td>
          <td>{{currentClientToView?.email}}</td>
        </tr>
        <tr>
          <td class="alignRight">Телефон:</td>
          <td>{{currentClientToView?.phone}}</td>
        </tr>
      </table>
    </div>

    <p-footer>
      <p-button class="btn btn-primary" (click)="closeClientWnd()" label="Закрыть">
      </p-button>
    </p-footer>
  </p-dialog>

</div>